import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsRosComponent } from './simple-icons-ros.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsRosComponent ],
    exports:      [ SimpleIconsRosComponent ],
    bootstrap:    []
})
export class SimpleIconsRosModule {}
